import { ProCard } from '@ant-design/pro-components'
import type { PatientOrderForm } from '@app/icare/entities/patientForm/schema/PatientForm'
import { useOrderArticleCart } from '@app/icare/form/entity/patientForm/hooks/useOrderArticleCart'
import { useAppFormContext } from '@app/icare/form/useAppForm'
import { t } from '@lingui/core/macro'
import { useEditablePolicy } from '@pkg/form/contexts/editableForm'
import { useStore } from '@tanstack/react-form'
import { createFileRoute } from '@tanstack/react-router'
import { Divider, Flex, Space, Typography } from 'antd'
import { FaUndo } from 'react-icons/fa'
import MissingAlert from './-components/missingAlert'
import ViewArticlesTable from './-components/ViewArticlesTable'
import { Articles } from './-steps/articles'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/$form/articles')({
  component: RouteComponent,
})

function RouteComponent() {
  const form = useAppFormContext<PatientOrderForm>()
  const { policy } = useEditablePolicy()
  const { cart, missing } = useOrderArticleCart({})
  const isEditing = policy.forceMode !== 'read'

  const state = useStore(form.store, s => ({
    isDirty: s.fieldMeta?.['form.articles']?.isDirty || s.fieldMeta?.['form.customArticles']?.isDirty || false,
    canSave: s.isDirty && !s.isSubmitting,
    isSaving: s.isSubmitting,
  }))

  return (
    <ProCard className="mt-4">
      <Flex vertical gap="small">
        <MissingAlert readonly={!isEditing} />
        {missing.hasMissing && isEditing && <Divider size="small" />}
        {isEditing && (
          <Flex justify="flex-end">
            <Space size={0}>
              {state.isDirty && (
                <Typography.Link
                  onClick={() => {
                    form.resetField('form.articles')
                    form.resetField('form.customArticles')
                  }}
                >
                  <Space>
                    <FaUndo className="size-3" />
                    {t`Artikel zurücksetzen`}
                  </Space>
                </Typography.Link>
              )}
            </Space>
          </Flex>
        )}
        {isEditing ? <Articles /> : <ViewArticlesTable articles={cart.articles} customArticles={cart.customArticles} />}
      </Flex>
    </ProCard>
  )
}
